import React from 'react';

interface CustomIconTrendChart5Props extends React.SVGProps<SVGSVGElement> {}

export function CustomIconTrendChart5({ height, width, ...props }: CustomIconTrendChart5Props) {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M4 20L4 5H7L7 20H4Z" fill="currentColor" fillOpacity="0.5" />
      <path fillRule="evenodd" clipRule="evenodd" d="M7 17L19 17V20L7 20L7 17Z" fill="currentColor" fillOpacity="0.5" />
      <path d="M6 15C8.5 15 9.9 15.5 11.5 13.5C13.5 11 14 9 19 9" stroke="currentColor" strokeWidth="2" />
      <path
        d="M19 12.5C11.6603 12.5 14 6.43496 10.5 6.5C7.29899 6.55949 9.00018 12 6.00018 12"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
